module.exports = __webpack_public_path__ + "static/media/RE_HabitBackgrounds.d7fa41e2.png";